export const items=[
    {
    id:1,
    name:'Slim Shit',
    category:'male',
    price:30,
    discout:4,
    featured:false,
    instock:true,
    rating:3.5,
    image:'./images/img1.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:2,
    name:'Ralph Wado Shit',
    category:'male',
    price:43,
    discout:2,
    featured:true,
    instock:false,
    rating:2.5,
    image:'./images/img2.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:3,
    name:'Kelvin Clein',
    category:'male',
    price:39,
    discout:2,
    featured:false,
    instock:true,
    rating:4.5,
    image:'./images/img3.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:4,
    name:'Fubu Shirt',
    category:'male',
    price:53,
    discout:2,
    featured:true,
    instock:true,
    rating:3,
    image:'./images/img4.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:5,
    name:'Wado Shirt',
    category:'male',
    price:33,
    discout:10,
    featured:true,
    instock:true,
    rating:4.5,
    image:'./images/img11.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:6,
    name:'Pdiddy Shirt',
    category:'male',
    price:74,
    discout:15,
    featured:false,
    instock:true,
    rating:3,
    image:'./images/img5.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:7,
    name:'Kamadon',
    category:'male',
    price:45,
    discout:2,
    featured:false,
    instock:true,
    rating:2.5,
    image:'./images/img6.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:8,
    name:'Bandy Shirt',
    category:'male',
    price:82,
    discout:4,
    featured:false,
    instock:true,
    rating:1.5,
    image:'./images/img7.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:9,
    name:'Ukodo',
    category:'male',
    price:60,
    discout:2,
    featured:false,
    instock:true,
    rating:3.5,
    image:'./images/img8.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:10,
    name:'Modenna',
    category:'male',
    price:76,
    discout:5,
    featured:true,
    instock:true,
    rating:3,
    image:'./images/img9.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
{
    id:11,
    name:'Viki',
    category:'male',
    price:15,
    discout:12,
    featured:false,
    instock:true,
    rating:1.5,
    image:'./images/img10.jpg',
    description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
},
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
// {
//     id:1,
//     name:'Slim Shit',
//     category:'male',
//     price:120.00,
//     discout:4,
//     featured:false,
//     instock:true,
//     rating:3.5,
//     image:'./images/img1.jpg',
//     description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo sequi ab quaerat molestias similique fugiat obcaecati maiores exercitationem saepe! Ex tempore consequuntur dignissimos modi maxime sunt sed magnam alias assumenda!'
// },
]